import { Outlet, useLocation } from "react-router-dom";
import MsHeader from "../../Components/MiniStore/Header/MsHeader";
import SocialButtonsFooter from "../../Components/MiniStore/Footer/socialButtonsFooter";
import HeroComponent from "../../Components/MiniStore/HeroComponent/HeroComponent";
import SearchBarGeneral from "../../Components/MiniStore/SearchBarGeneral/SearchBarGeneral";
import GeneralTabs from "../../Components/MiniStore/GeneralTabs/GeneralTabs";
import GoogleAnalyticsTracker from "../../Components/GoogleAnalytics/GoogleAnalyticsTracker";
import MsCartButton from "./MsCart/MsCartButton";
import { Helmet } from "react-helmet-async";
import { useContext, useEffect } from "react";
import { MiniStoreThemeContext } from "../../MiniStoreContexts/MiniStoreThemeContext";
import { CartContext } from "../../contexts/MiniStore/CartContext";
import { useSession } from "../../authentications/SessionContext";
import { getToken } from "../../DataApi/miniStore/getToken";
import { cartUpdate } from "../../DataApi/miniStore/cartUpdate";

const MiniStoreLayout = () => {
  const location = useLocation();
  const { theme } = useContext(MiniStoreThemeContext);
  const {
    cart,
    setCart,
    setSubTotal,
    setTotal,
    setCurrency,
    setCartCount,
    setCartTax,
    setShippingCost,
    setCartLoading,
    cartExpiry,
    CART_STORAGE_KEY,
    CART_EXPIRY_KEY,
    getExpiryTimestamp,
  } = useContext(CartContext);
  const { setPublicPartnerId } = useSession();

  const getCartData = async () => {
    try {
      const tokenData = await getToken();
      if (!tokenData?.token) return;
      const token = tokenData.token;

      const orderId =
        cart.find((item) => item.order_id !== undefined)?.order_id || false;

      const vals = {};
      const response = await cartUpdate({ token, order_id: orderId, vals });

      if (
        response?.status === 200 &&
        typeof response.result.partner_id === "number"
      ) {
        setPublicPartnerId(response.result.partner_id || null);
      }

      if (
        response?.status === 200 &&
        Array.isArray(response.result.order_line)
      ) {
        const syncedCart = response.result.order_line.map((apiItem) => ({
          id: apiItem.id,
          line_id: apiItem.line_id,
          template_id: apiItem.template_id || null,
          title: apiItem.name,
          description: apiItem.description_sale,
          rating: apiItem.rating,
          quantity: apiItem.quantity,
          currency: apiItem.currency,
          price: apiItem.price,
          newPrice: apiItem.newPrice,
          has_discounted_price: apiItem.has_discounted_price,
          totalPrice: apiItem.totalPrice,
          discount: apiItem.discount,
          image_1920: apiItem.image,
          hasVariant: apiItem.hasVariant,
          order_id: response.order_id,
        }));

        let {
          amount_untaxed,
          amount_total,
          currency_name,
          amount_tax,
          amount_delivery,
          cart_quantity,
        } = response.result;
        currency_name = currency_name || "";
        setCart(syncedCart);
        setCurrency(currency_name || "");
        setSubTotal(`${currency_name || ""} ${amount_untaxed.toFixed(2)}`);
        setTotal(`${currency_name || ""} ${amount_total.toFixed(2)}`);
        setCartCount(cart_quantity);
        setShippingCost(amount_delivery);
        setCartTax(amount_tax);
        // Save everything to localStorage
        localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(syncedCart));
        localStorage.setItem(
          CART_EXPIRY_KEY,
          getExpiryTimestamp(cartExpiry).toString()
        );
        localStorage.setItem("currency", currency_name || "");
        localStorage.setItem(
          "subTotal",
          `${currency_name || ""} ${amount_untaxed.toFixed(2)}`
        );
        localStorage.setItem(
          "total",
          `${currency_name || ""} ${amount_total.toFixed(2)}`
        );
        localStorage.setItem("cartCount", cart_quantity.toString());
        localStorage.setItem("shippingCost", amount_delivery.toString());
        localStorage.setItem("cartTax", amount_tax.toString());
      }
    } catch (err) {
      console.error("Fetch cart error:", err);
    } finally {
      setCartLoading(false);
    }
  };

  // Call cart sync on every page load and route change
  useEffect(() => {
    getCartData();
  }, [location.pathname]);
  const showGeneralComponents =
    location.pathname.includes("home") || location.pathname.includes("shop");
  return (
    <div className="storefront-container">
     <GoogleAnalyticsTracker/>
      <Helmet>
        <title>{theme?.name || "Storefront"}</title>
        <meta name={theme?.name || "Storefront"} />
      </Helmet>
      <header>
        <MsHeader />
      </header>
      <main>
        <div className="container-fluid d-flex flex-column">
          {showGeneralComponents && (
            <>
              <HeroComponent />
              <SearchBarGeneral />
              <GeneralTabs />
            </>
          )}
          <Outlet />
          {showGeneralComponents && (
            <>
              <MsCartButton />
            </>
          )}
        </div>
      </main>
      <footer style={{ marginTop: "60px" }}>
        <SocialButtonsFooter />
      </footer>
    </div>
  );
};

export default MiniStoreLayout;
